export default {
  NotSupportedOperation: '不支持该操作',
  NoMatchingData: '无匹配数据'
}
